import adminRoutes from "@/routes/adminRoutes";
import aemRoutes from "@/routes/aemRoutes";
import affiliationRoutes from "@/routes/affiliationRoutes";
import commonRoutes from "@/routes/commonRoutes";
import contentRoutes from "@/routes/contentRoutes";
import studentRoutes from "@/routes/studentRoutes";
import tutoringRoutes from "@/routes/tutoringRoutes";
import uiKitRoutes from "@/routes/uiKitRoutes";
import type { RouteRecordRaw } from "vue-router";

// Every route module in one array, with no router instance attached. router.ts builds the real
// router from this; anything that only needs to *read* the route table (the navbar config screen
// matching ViewNamesEnum entries to real screens) imports it here instead of pulling in
// createRouter and its store dependencies.
export const allRoutes = commonRoutes
  .concat(studentRoutes)
  .concat(affiliationRoutes)
  .concat(adminRoutes)
  .concat(contentRoutes)
  .concat(aemRoutes)
  .concat(tutoringRoutes)
  .concat(uiKitRoutes) as Array<RouteRecordRaw>;

function collectPaths(routes: Array<RouteRecordRaw>, parentPath: string, into: Map<string, string>) {
  routes.forEach((route) => {
    // Children declare relative paths, so a child's URL is its parent's path plus its own.
    const path = route.path.startsWith("/")
      ? route.path
      : `${parentPath.replace(/\/$/, "")}/${route.path}`;
    if (route.name) {
      into.set(String(route.name), path);
    }
    if (route.children?.length) {
      collectPaths(route.children as Array<RouteRecordRaw>, path, into);
    }
  });
}

// Route name → URL path. Route names are kept identical to their ViewNamesEnum entry, which is
// what lets an admin screen show the real path behind a view name.
export const ROUTE_PATH_BY_NAME: Map<string, string> = (() => {
  const paths = new Map<string, string>();
  collectPaths(allRoutes, "", paths);
  return paths;
})();
